export default function PaginaNaoEncontrada(props) {
    document.body.style.backgroundColor = '#ffffff';
    document.title = 'Erro - Página não Encontrada!';
    return (    
        <h1 align="center">Página não encontrada</h1>
    );
}